import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
    Card, CardBody, Col,
} from 'reactstrap';
import ReactTableBase from '../../../../shared/components/table/ReactTableBase';
import ReactTableCustomizer from '../../../../shared/components/table/components/ReactTableCustomizer';
import { useTranslation } from 'react-i18next';
import { useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";

const reorder = (rows, startIndex, endIndex) => {
    const result = Array.from(rows);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
};

const SatisfactionSurveyTable = ({ title, reactTableData }) => {
    const { t } = useTranslation('common');

    const [rows, setData] = useState(reactTableData);
    const [isEditable, setIsEditable] = useState(false);
    const [isResizable, setIsResizable] = useState(false);
    const [isSortable, setIsSortable] = useState(false);
    const [isDisabledDragAndDrop, setIsDisabledDragAndDrop] = useState(false);
    const [isDisabledEditable, setIsDisabledEditable] = useState(false);
    const [isDisabledResizable, setIsDisabledResizable] = useState(false);
    const [withDragAndDrop, setWithDragAndDrop] = useState(false);
    const [withPagination, setWithPaginationTable] = useState(true);
    const [withSearchEngine, setWithSearchEngine] = useState(true);

    const handleClickIsEditable = () => {
        if (!withDragAndDrop) setIsDisabledResizable(!isDisabledResizable);
        setIsResizable(false);
        setIsEditable(!isEditable);
    };
    const handleClickIsResizable = () => {
        setIsEditable(false);
        setWithDragAndDrop(false);
        setIsDisabledDragAndDrop(!isDisabledDragAndDrop);
        setIsDisabledEditable(!isDisabledEditable);
        setIsResizable(!isResizable);
    };
    const handleClickIsSortable = () => {
        setIsSortable(!isSortable);
    };
    const handleClickWithDragAndDrop = () => {
        if (!isEditable) setIsDisabledResizable(!isDisabledResizable);
        setIsResizable(false);
        setWithDragAndDrop(!withDragAndDrop);
    };
    const handleClickWithPagination = () => {
        setWithPaginationTable(!withPagination);
    };
    const handleClickWithSearchEngine = () => {
        setWithSearchEngine(!withSearchEngine);
    };

    const updateDraggableData = (result) => {
        const items = reorder(
            rows,
            result.source.index,
            result.destination.index,
        );
        setData(items);
    };

    const updateEditableData = (rowIndex, columnId, value) => {
        setData(old => old.map((item, index) => {
            if (index === rowIndex) {
                return {
                    ...old[rowIndex],
                    [columnId]: value,
                };
            }
            return item;
        }));
    };
    const history = useHistory();

    const tableConfig = {
        isEditable,
        isResizable,
        isSortable,
        withDragAndDrop,
        withPagination,
        withSearchEngine,
        placeholder: 'Buscar Paciente',
        manualPageSize: [5, 10, 15, 20],
        /*useActions: true,
        actions: (data) => ReactTableActions({ data, Callback }),*/
    };

    const columnsData = [
        {
            Header: "Mes",
            accessor: 'mes',
            Cell: row => (
                <label>
                    {row.value}
                </label>
            )
        },
        {
            Header: "Muy Buena",
            accessor: 'muyBuena',
            Cell: row => (
                <label>
                    {row.value}
                </label>
            )
        },
        {
            Header: "Buena",
            accessor: 'buena',
            Cell: row => (
                <label>
                    {row.value}
                </label>
            )
        },
        {
            Header: "Regular",
            accessor: 'regular',
            Cell: row => (
                <label>
                    {row.value}
                </label>
            )
        },
        {
            Header: "Mala",
            accessor: 'mala',
            Cell: row => (
                <label>
                    {row.value}
                </label>
            )
        },
        {
            Header: "Muy Mala",
            accessor: 'muyMala',
            Cell: row => (
                <label>
                    {row.value}
                </label>
            )
        },
        {
            Header: "Total",
            accessor: 'total',
            Cell: row => (
                <label>
                    {row.value}
                </label>
            )
        },
        {
            Header: "Porcentaje Muy Buena",
            accessor: 'porcentajeMuyBuena',
            Cell: row => (
                <label>
                    {row.value} %
                </label>
            )
        },
        {
            Header: "Porcentaje Buena",
            accessor: 'porcentajeBuena',
            Cell: row => (
                <label>
                    {row.value} %
                </label>
            )
        },
        {
            Header: "Porcentaje Regular",
            accessor: 'porcentajeRegular',
            Cell: row => (
                <label>
                    {row.value} %
                </label>
            )
        },
        {
            Header: "Porcentaje Mala",
            accessor: 'porcentajeMala',
            Cell: row => (
                <label>
                    {row.value} %
                </label>
            )
        },
        {
            Header: "Porcentaje Muy Mala",
            accessor: 'porcentajeMuyMala',
            Cell: row => (
                <label>
                    {row.value} %
                </label>
            )
        }
    ];

    useEffect(() => {
    }, []);


    return (
        <Col md={12} lg={12}>
            <Card>
                <CardBody>
                    <div className="react-table__wrapper">

                    </div>
                    <ReactTableBase
                        key={withSearchEngine || isResizable || isEditable ? 'modified' : 'common'}
                        columns={columnsData}
                        data={rows}
                        updateEditableData={updateEditableData}
                        updateDraggableData={updateDraggableData}
                        tableConfig={tableConfig}
                    />
                </CardBody>
            </Card>
        </Col>
    );
};

SatisfactionSurveyTable.propTypes = {
    tableRowsData: PropTypes.arrayOf(PropTypes.shape()),
    defaultTableHeaderData: PropTypes.arrayOf(PropTypes.shape()),
    defaultTableRowData: PropTypes.arrayOf(PropTypes.shape())
};

export default SatisfactionSurveyTable;
